module.exports = __webpack_public_path__ + "transnistria.svg?9ddf9349d4f24d78faef25ae2ad55259";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/transnistria.svg
// module id = 321
// module chunks = 10